import React, { Fragment } from 'react';

// Components

import DisabilityInfo from './DisabilityInfo';
import FosterCareInfo from './FosterCareInfo';
import FullTimeStudentInfo from './FullTimeStudentInfo';
import HouseholdInfo from './HouseholdInfo';
import MedicaidChipInfo from './MedicaidChipInfo';
import MedicaidTerminationDetailsInfo from './MedicaidTerminationDetailsInfo';
import ParentCareTakerInfo from './ParentCareTakerInfo';
import PregnancyInfo from './PregnancyInfo';

// Constants

import { flowTypes as FLOW_TYPES } from '@constants/ssap/flows/flowTypes';



const FinancialFlowSecondSectionInfo = props => {

    const {
        exchangeAndProgramNames,
        flowType,
        idx,
        isState,
        medicaidEndDateOverride,
        medicaidTerminationFeatureEnabled,
        relations,
        serverDate,
        stateCode,
        member,
        member: {
            applyingForCoverageIndicator,
            blindOrDisabled,
            changeInImmigrationSince5Year,
            changeInImmigrationSinceMedicaidDenial,
            dateOfBirth,
            evaluateForMedicaidIndicator,
            fullTimeStudent,
            householdIncomeOrSizeChanged,
            longTermCare,
            medicaidChipDenial,
            medicaidChipExpirationDate,
            medicaidDeniedDate,
            medicaidDeniedDueToImmigration,
            medicaidTermination,
            parentCaretaker,
            personId,
            specialCircumstances: {
                ageWhenLeftFosterCare,
                currentlyPregnant,
                dueDateOfPregnancy,
                endDateOfPregnancy,
                everInFosterCareIndicator,
                fosterCareState,
                gettingHealthCareThroughStateMedicaidIndicator,
                numberBabiesExpectedInPregnancy,
                pregnantIndicator
            },
            taxHouseholdComposition
        },
        taxHousehold
    } = props;

    if(flowType !== FLOW_TYPES.FINANCIAL_FLOW) {
        return null;
    }
    
    return (
        <Fragment>
            <HouseholdInfo
                { ...{
                    idx,
                    personId,
                    relations,
                    serverDate,
                    taxHousehold,
                    taxHouseholdComposition
                } }
            />

            <ParentCareTakerInfo
                { ...{
                    idx,
                    parentCaretaker
                } }
            />

            <MedicaidTerminationDetailsInfo
                { ...{
                    applyingForCoverageIndicator,
                    exchangeAndProgramNames,
                    idx,
                    householdIncomeOrSizeChanged,
                    medicaidChipExpirationDate,
                    medicaidTermination,
                    medicaidTerminationFeatureEnabled
                } }
            />

            <MedicaidChipInfo
                { ...{
                    applyingForCoverageIndicator,
                    changeInImmigrationSince5Year,
                    changeInImmigrationSinceMedicaidDenial,
                    exchangeAndProgramNames,
                    idx,
                    medicaidChipDenial,
                    medicaidDeniedDate,
                    medicaidDeniedDueToImmigration,
                    medicaidEndDateOverride,
                    medicaidTerminationFeatureEnabled,
                    member,
                    serverDate
                } }
            />

            <PregnancyInfo
                { ...{
                    currentlyPregnant,
                    dueDateOfPregnancy,
                    endDateOfPregnancy,
                    evaluateForMedicaidIndicator,
                    exchangeAndProgramNames,
                    idx,
                    isState,
                    member,
                    numberBabiesExpectedInPregnancy,
                    pregnantIndicator,
                    serverDate,
                    stateCode
                } }
            />


            <FosterCareInfo
                { ...{
                    ageWhenLeftFosterCare,
                    applyingForCoverageIndicator,
                    dateOfBirth,
                    everInFosterCareIndicator,
                    gettingHealthCareThroughStateMedicaidIndicator,
                    fosterCareState,
                    idx,
                    serverDate
                } }
            />

            <FullTimeStudentInfo
                { ...{
                    applyingForCoverageIndicator,
                    dateOfBirth,
                    idx,
                    fullTimeStudent,
                    serverDate
                } }
            />


            <DisabilityInfo
                { ...{
                    applyingForCoverageIndicator,
                    blindOrDisabled,
                    idx,
                    longTermCare
                } }
            />
        </Fragment>
    );
};

export default FinancialFlowSecondSectionInfo;